<h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level esf-action-heading--tile">
  <span i18n='Club section title@@clubOverviewComponent.sectionHeading.clubData' class="esf-action-heading__text">Club data</span>
  <span class="esf-action-heading__actions">
    <span class="esf-action-heading__action">
      <button class="esf-button esf-button--simple"
              (click)="clubOverviewService.toggleAllModal(false);clubOverviewService.toggleEditClubDataModal(true);"
              [edsTooltip]="tooltipTranslations.i18nEdit">
        <svg class="esf-icon esf-button__icon" width="16" height="16">
          <use xlink:href="#esf-icon-edit"></use>
        </svg>
        <span class="esf-button__icon-text"></span>
      </button>
    </span>
  </span>
</h4>
<div class="esf-info-tile" style="flex: 1;">
  <div class="esf-info-tile__content">
    <div class="esf-grid esf-grid--gutter-y-xxs esf-grid--x-between esf-grid--center-y">
      <div class="esf-grid__item">
        <div class="esf-icon-and-text esf-icon-and-text--xs">
          <span class="esf-tooltip esf-tooltip--top" i18n-data-tooltip='Tooltip@@general.tooltip.clubNumber' data-tooltip="Club Number">
            <svg class="esf-icon" width="16" height="16">
              <use xlink:href="#esf-icon-membership-number"></use>
            </svg>
          </span>
          <div class="esf-icon-and-text__text club-id">{{ selectedClub.id || '/' }}</div>
        </div>
      </div>
      <div class="esf-grid__item">
        <a class="esf-tag" [ngClass]="selectedClub.statusCssClass">{{ selectedClub.translatedClubStatus }}</a>
      </div>
    </div>
    <p>
      <small>
        <span class="name">{{ selectedClub.name }}</span><br>
      </small>
    </p>
  </div>
</div>
